import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ptTranslations from './locales/pt/translation.json';
import enTranslations from './locales/en/translation.json';
import esTranslations from './locales/es/translation.json';

const resources = {
  pt: {
    translation: ptTranslations
  },
  en: {
    translation: enTranslations
  },
  es: {
    translation: esTranslations
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    // App em português: as telas novas têm texto fixo em PT; en/es ficam como base para a
    // tradução completa (backlog). O seletor de idioma foi removido por traduzir só partes.
    lng: 'pt',
    fallbackLng: 'pt',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n; 